import React, { useState, useEffect, Fragment } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import swal from "sweetalert";
import MainPagetitle from "../../layouts/MainPagetitle";
import { Offcanvas } from "react-bootstrap";
import ClipLoader from "react-spinners/ClipLoader";
import DateComponent from "../../components/date/DateFormat";
import ColumnReOrderPopup from "../../popup/ColumnReOrderPopup";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import "../../pages/Subdivision/subdivisionList.css";
import CouponOffcanvas from "./CouponOffcanvas";
import AdminCouponService from "../../../API/Services/AdminService/AdminCouponService";

const CouponList = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const page =
    JSON.parse(queryParams.get("page")) === 1
      ? null
      : JSON.parse(queryParams.get("page"));

  const [Error, setError] = useState("");
  const navigate = useNavigate();
  const [couponList, setCouponList] = useState([]);
  const [landSaleListCount, setlandSaleListCount] = useState("");
  const [pageChange, setPageChange] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const recordsPage = 100;
  const lastIndex = currentPage * recordsPage;
  const firstIndex = lastIndex - recordsPage;
  const [npage, setNpage] = useState(0);
  const number = [...Array(npage + 1).keys()].slice(1);
  const [canvasShowAdd, seCanvasShowAdd] = useState(false);
  const [showOffcanvas, setShowOffcanvas] = useState(false);
  const [couponDetails, setCouponDetails] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [isFormLoading, setIsFormLoading] = useState(false);

  useEffect(() => {
    if (localStorage.getItem("usertoken")) {
      // if (!manageFilterOffcanvas) {
      if (page === currentPage) {
        return;
      } else {
        getCouponList(page === null ? currentPage : JSON.parse(page));
        // page === null ? currentPage : JSON.parse(page),
        // sortConfig,
        // searchQuery,
      }
      // }
    } else {
      navigate("/");
    }
  }, [currentPage]);

  const clearLandSaleDetails = () => {
    setCouponDetails({});
  };

  // const checkFieldExist = (fieldName) => {
  //   return fieldList.includes(fieldName.trim());
  // };

  const columnsName = [
    { label: "Coupon Code", key: "Coupon_Code", id: 1 },
    { label: "Coupon used", key: "Coupon_used", id: 2 },
    { label: "Flat Discount", key: "Flat_Discount", id: 3 },
    { label: "Expiry Date", key: "Expiry_Date", id: 4 },
    { label: "Action", key: "Action", id: 5 },
  ];

  const prePage = () => {
    if (currentPage !== 1) {
      setPageChange(true);
      setCurrentPage(currentPage - 1);
    }
  };

  const changeCPage = (id) => {
    setCurrentPage(id);
    setPageChange(true);
  };

  const nextPage = () => {
    if (currentPage !== npage) {
      setPageChange(true);
      setCurrentPage(currentPage + 1);
    }
  };

  const getCouponList = async (currentPage) => {
    setIsLoading(true);
    setCurrentPage(currentPage);
    // setSearchQuery(searchQuery);
    // localStorage.setItem(
    //   "searchQueryByLandSalesFilter",
    //   JSON.stringify(searchQuery),
    // );
    try {
      // let sortConfigString = "";
      // if (sortConfig !== null) {
      //   sortConfigString = "&sortConfig=" + stringifySortConfig(sortConfig);
      // }
      const response = await AdminCouponService.index(currentPage);
      // currentPage,
      // sortConfigString,
      // searchQuery,
      // ();
      const responseData = await response.json();
      setIsLoading(false);
      setPageChange(false);
      setCouponList(responseData?.data);
      setNpage(Math.ceil(responseData?.total / recordsPage));
      setlandSaleListCount(responseData?.total);
      // setHandleCallBack(true);
      // if (responseData?.meta?.total > 100) {
      //   if (!pageChange) {
      //     FetchAllPages(
      //       // searchQuery,
      //       sortConfig,
      //       responseData.data,
      //       responseData.meta.total,
      //     );
      //   }
      // } else {
      //   if (!pageChange) {
      //     setAllBuilderExport(responseData.data);
      //   }
      // }
    } catch (error) {
      if (error.name === "HTTPError") {
        setIsLoading(false);
        const errorJson = await error.response.json();
        setError(errorJson.message);
      }
    }
    setIsLoading(false);
  };

  // const FetchAllPages = async (
  //   searchQuery,
  //   sortConfig,
  //   couponList,
  //   landSaleListCount,
  // ) => {
  //   setExcelLoading(true);
  //   const totalPages = Math.ceil(landSaleListCount / recordsPage);
  //   let allData = couponList;
  //   if (page !== null) {
  //     for (let pageNum = 1; pageNum <= totalPages; pageNum++) {
  //       // await delay(1000);
  //       if (pageNum === page) continue;
  //       const pageResponse = await AdminLandsaleService.index(
  //         pageNum,
  //         searchQuery,
  //         sortConfig ? `&sortConfig=${stringifySortConfig(sortConfig)}` : "",
  //       );
  //       const pageData = await pageResponse.json();
  //       allData = allData.concat(pageData.data);
  //     }
  //     setAllBuilderExport(allData);
  //     setExcelLoading(false);
  //     setHandleCallBack(true);
  //   } else {
  //     for (let page = 2; page <= totalPages; page++) {
  //       // await delay(1000);
  //       const pageResponse = await AdminLandsaleService.index(
  //         page,
  //         searchQuery,
  //         sortConfig ? `&sortConfig=${stringifySortConfig(sortConfig)}` : "",
  //       );
  //       const pageData = await pageResponse.json();
  //       allData = allData.concat(pageData.data);
  //     }
  //     setAllBuilderExport(allData);
  //     setExcelLoading(false);
  //     setHandleCallBack(true);
  //   }
  // };

  const handleDelete = async (e) => {
    try {
      let responseData = await AdminCouponService.destroy(e).json();

      if (responseData) {
        getCouponList(currentPage);
      }
    } catch (error) {
      if (error.name === "HTTPError") {
        const errorJson = await error.response.json();
        setError(errorJson.message);
      }
    }
  };

  // const handleBulkDelete = async (id) => {
  //   try {
  //     let responseData = await AdminLandsaleService.bulkdestroy(id).json();
  //     if (responseData.status === true) {
  //       getCouponList(currentPage, sortConfig, searchQuery);
  //     }
  //   } catch (error) {
  //     if (error.name === "HTTPError") {
  //       const errorJson = await error.response.json();
  //       setError(errorJson.message);
  //     }
  //   }
  // };

  const handleCallback = () => {
    getCouponList(currentPage);
  };

  const handleRowClick = async (id) => {
    setShowOffcanvas(true);
    setIsFormLoading(true);
    try {
      let responseData = await AdminCouponService.show(id).json();
      setCouponDetails(responseData);
      console.log("ppp", responseData);

      setIsFormLoading(false);
    } catch (error) {
      if (error.name === "HTTPError") {
        setIsFormLoading(false);
        const errorJson = await error.response.json();
        setError(errorJson.message);
      }
    }
  };

  return (
    <Fragment>
      <MainPagetitle mainTitle="Coupon" pageTitle="Coupon" parentTitle="Home" />
      <div className="container-fluid">
        <div className="row">
          <div className="col-xl-12">
            <div className="card">
              <div className="card-body p-0">
                <div className="table-responsive active-projects style-1 ItemsCheckboxSec shorting">
                  <div className="tbl-caption d-flex justify-content-between text-wrap align-items-center pb-0">
                    <div className="d-flex text-nowrap justify-content-between align-items-center">
                      <h4 className="heading mb-0">Coupon List</h4>
                      <div
                        className="btn-group mx-5"
                        role="group"
                        aria-label="Basic example"
                      ></div>
                      {/* <ColumnReOrderPopup
                        open={openDialog}
                        fieldList={fieldList}
                        handleCloseDialog={handleCloseDialog}
                        handleSaveDialog={handleSaveDialog}
                        draggedColumns={draggedColumns}
                        handleColumnOrderChange={handleColumnOrderChange}
                      /> */}
                    </div>

                    <div className="mt-2" style={{ width: "100%" }}>
                      <div className="d-flex">
                        {/* <button
                            className="btn btn-primary btn-sm me-1"
                            onClick={handleOpenDialog}
                            title="Column Order"
                          >
                            <div style={{ fontSize: "11px" }}>
                              <i className="fa-solid fa-list"></i>&nbsp; Column
                              Order
                            </div>
                          </button> */}
                        {/* <Button
                            className="btn-sm me-1"
                            variant="secondary"
                            onClick={HandleSortingPopupDetailClick}
                            title="Sorted Fields"
                          >
                            <div style={{ fontSize: "11px" }}>
                              <i className="fa-solid fa-sort"></i>&nbsp; Sort
                            </div>
                          </Button> */}
                        {/* <button
                            disabled={excelDownload || couponList?.length === 0}
                            onClick={() => setExportModelShow(true)}
                            className="btn btn-primary btn-sm me-1"
                            title="Export .csv"
                          >
                            <div style={{ fontSize: "11px" }}>
                              <i className="fas fa-file-export" />
                              &nbsp;
                              {excelDownload ? "Downloading..." : "Export"}
                            </div>
                          </button> */}
                        {/* <button
                            className="btn btn-success btn-sm me-1"
                            onClick={() => setManageFilterOffcanvas(true)}
                            title="Filter"
                          >
                            <div style={{ fontSize: "11px" }}>
                              <i className="fa fa-filter" />
                              &nbsp; Filter
                            </div>
                          </button> */}
                        {/* <Button
                            className="btn btn-primary btn-sm me-1"
                            onClick={() =>
                              !excelLoading ? addToBuilderList() : ""
                            }
                          >
                            {excelLoading ? (
                              <div
                                className="spinner-border spinner-border-sm"
                                role="status"
                              />
                            ) : (
                              <div style={{ fontSize: "11px" }}>
                                <i
                                  className="fa fa-map-marker"
                                  aria-hidden="true"
                                />
                                &nbsp; Map
                              </div>
                            )}
                          </Button> */}
                        {/* <button
                            className="btn btn-primary btn-sm me-1"
                            onClick={() => setManageAccessOffcanvas(true)}
                          >
                            <div style={{ fontSize: "11px" }}>
                              <i className="fa fa-shield" />
                              &nbsp; Field Access
                            </div>
                          </button> */}
                        {/* <Button
                            className="btn-sm me-1"
                            variant="secondary"
                            onClick={handlBuilderClick}
                          >
                            <div style={{ fontSize: "11px" }}>
                              <i className="fas fa-file-import" />
                              &nbsp; Import
                            </div>
                          </Button> */}
                        <Link
                          to={"#"}
                          className="btn btn-primary btn-sm ms-1"
                          data-bs-toggle="offcanvas"
                          onClick={() => seCanvasShowAdd(true)}
                        >
                          <div style={{ fontSize: "11px" }}>
                            <i className="fa fa-plus" />
                            &nbsp; Add Coupon
                          </div>
                        </Link>
                        {/* <Link
                            to={"#"}
                            className="btn btn-primary btn-sm ms-1"
                            data-bs-toggle="offcanvas"
                            onClick={() =>
                              selectedCoupon.length > 0
                                ? seCanvasShowEdit(true)
                                : swal({
                                    text: "Please select at least one record.",
                                    icon: "warning",
                                    dangerMode: true,
                                  })
                            }
                          >
                            <div style={{ fontSize: "11px" }}>
                              <i className="fa fa-pencil" />
                              &nbsp; Edit
                            </div>
                          </Link> */}
                        {/* <button
                            className="btn btn-danger btn-sm me-1"
                            style={{ marginLeft: "3px" }}
                            onClick={() =>
                              selectedCoupon.length > 0
                                ? swal({
                                    title: "Are you sure?",
                                    icon: "warning",
                                    buttons: true,
                                    dangerMode: true,
                                  }).then((willDelete) => {
                                    if (willDelete) {
                                      handleBulkDelete(selectedCoupon);
                                    }
                                  })
                                : ""
                            }
                          >
                            <div style={{ fontSize: "11px" }}>
                              <i className="fa fa-trash" />
                              &nbsp; Delete
                            </div>
                          </button> */}
                      </div>
                    </div>
                  </div>
                  <div className="d-sm-flex text-center justify-content-between align-items-center dataTables_wrapper no-footer">
                    <div className="dataTables_info">
                      Showing {lastIndex - recordsPage + 1} to {lastIndex} of{" "}
                      {landSaleListCount} entries
                    </div>
                    <div
                      className="dataTables_paginate paging_simple_numbers justify-content-center"
                      id="example2_paginate"
                    >
                      <Link
                        className="paginate_button previous disabled"
                        to="#"
                        onClick={prePage}
                      >
                        <i className="fa-solid fa-angle-left" />
                      </Link>
                      <span>
                        {number.map((n, i) => {
                          if (number.length > 4) {
                            if (
                              i === 0 ||
                              i === number.length - 1 ||
                              Math.abs(currentPage - n) <= 1 ||
                              (i === 1 && n === 2) ||
                              (i === number.length - 2 &&
                                n === number.length - 1)
                            ) {
                              return (
                                <Link
                                  className={`paginate_button ${
                                    currentPage === n ? "current" : ""
                                  } `}
                                  key={i}
                                  onClick={() => changeCPage(n)}
                                >
                                  {n}
                                </Link>
                              );
                            } else if (i === 1 || i === number.length - 2) {
                              return <span key={i}>...</span>;
                            } else {
                              return null;
                            }
                          } else {
                            return (
                              <Link
                                className={`paginate_button ${
                                  currentPage === n ? "current" : ""
                                } `}
                                key={i}
                                onClick={() => changeCPage(n)}
                              >
                                {n}
                              </Link>
                            );
                          }
                        })}
                      </span>

                      <Link
                        className="paginate_button next"
                        to="#"
                        onClick={nextPage}
                      >
                        <i className="fa-solid fa-angle-right" />
                      </Link>
                    </div>
                  </div>
                  <div
                    id="employee-tbl_wrapper"
                    className="dataTables_wrapper no-footer"
                  >
                    {isLoading ? (
                      <div className="d-flex justify-content-center align-items-center mb-5">
                        <ClipLoader color="#4474fc" />
                      </div>
                    ) : (
                      <table
                        id="empoloyees-tblwrapper"
                        className="table ItemsCheckboxSec dataTable no-footer mb-0 landsale-table"
                      >
                        <thead>
                          <tr style={{ textAlign: "center" }}>
                            {/* <th>
                              <input
                                type="checkbox"
                                style={{ cursor: "pointer" }}
                                checked={
                                  currentPage == samePage || isSelectAll
                                    ? selectCheckBox
                                    : ""
                                }
                                onClick={(e) => handleMainCheckboxChange(e)}
                              />
                            </th> */}
                            <th>
                              <strong> No. </strong>
                            </th>

                            {columnsName.map((column) => (
                              <th
                                style={{
                                  textAlign: "center",
                                  cursor: "pointer",
                                }}
                                // key={column.id}
                              >
                                <strong>
                                  {column.label}
                                  {/* {column.id != "action" &&
                                    sortConfig.some(
                                      (item) =>
                                        item.key ===
                                        (column.id == "size MS"
                                          ? "typeofunit"
                                          : column.id == "size"
                                            ? "noofunit"
                                            : column.id == "zIP Code"
                                              ? "zip"
                                              : toCamelCase(column.id)),
                                    ) && (
                                      <span>
                                        {column.id != "action" &&
                                        sortConfig.find(
                                          (item) =>
                                            item.key ===
                                            (column.id == "size MS"
                                              ? "typeofunit"
                                              : column.id == "size"
                                                ? "noofunit"
                                                : column.id == "zIP Code"
                                                  ? "zip"
                                                  : toCamelCase(column.id)),
                                        ).direction === "asc"
                                          ? "↑"
                                          : "↓"}
                                      </span>
                                    )} */}
                                </strong>
                              </th>
                            ))}
                          </tr>
                        </thead>
                        <tbody style={{ textAlign: "center" }}>
                          {couponList !== null && couponList?.length > 0 ? (
                            couponList.map((element, index) => (
                              <tr
                                onClick={(e) => {
                                  if (e.target.type == "checkbox") {
                                    return;
                                  } else if (
                                    e.target.className ==
                                      "btn btn-danger shadow btn-xs sharp" ||
                                    e.target.className == "fa fa-trash"
                                  ) {
                                    return;
                                  } else {
                                    handleRowClick(element.id);
                                  }
                                }}
                                style={{
                                  textAlign: "center",
                                  cursor: "pointer",
                                }}
                              >
                                {/* <td>
                                  <input
                                    type="checkbox"
                                    checked={selectedCoupon.includes(
                                      element.id,
                                    )}
                                    onChange={(e) =>
                                      handleEditCheckboxChange(e, element.id)
                                    }
                                    style={{
                                      cursor: "pointer",
                                    }}
                                  />
                                </td> */}
                                <td>{index + 1}</td>
                                <td>{element?.title}</td>
                                <td>{`${element?.users?.filter(user => user.pivot?.used_at != null).length ?? 0} / ${element?.users.length ?? 0} users`}</td>
                                <td>${Math.trunc(element?.value)}</td>
                                <td>
                                  <DateComponent date={element?.valid_until} />
                                </td>

                                <td
                                  // key={column.id}
                                  style={{ textAlign: "center" }}
                                >
                                  <div className="d-flex justify-content-center">
                                    {/* <Link
                                      to={`/landsaleupdate/${element.id}?page=${currentPage}`}
                                      className="btn btn-primary shadow btn-xs sharp me-1"
                                    >
                                      <i className="fas fa-pencil-alt"></i>
                                    </Link> */}
                                    <Link
                                      onClick={() =>
                                        swal({
                                          title: "Are you sure?",
                                          icon: "warning",
                                          buttons: true,
                                          dangerMode: true,
                                        }).then((willDelete) => {
                                          if (willDelete) {
                                            handleDelete(element.id);
                                          }
                                        })
                                      }
                                      className="btn btn-danger shadow btn-xs sharp"
                                    >
                                      <i className="fa fa-trash"></i>
                                    </Link>
                                  </div>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="17" style={{ textAlign: "center" }}>
                                No data found
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    )}
                  </div>
                  <div className="d-sm-flex text-center justify-content-between align-items-center dataTables_wrapper no-footer">
                    <div className="dataTables_info">
                      Showing {lastIndex - recordsPage + 1} to {lastIndex} of{" "}
                      {landSaleListCount} entries
                    </div>
                    <div
                      className="dataTables_paginate paging_simple_numbers justify-content-center"
                      id="example2_paginate"
                    >
                      <Link
                        className="paginate_button previous disabled"
                        to="#"
                        onClick={prePage}
                      >
                        <i className="fa-solid fa-angle-left" />
                      </Link>
                      <span>
                        {number.map((n, i) => {
                          if (number.length > 4) {
                            if (
                              i === 0 ||
                              i === number.length - 1 ||
                              Math.abs(currentPage - n) <= 1 ||
                              (i === 1 && n === 2) ||
                              (i === number.length - 2 &&
                                n === number.length - 1)
                            ) {
                              return (
                                <Link
                                  className={`paginate_button ${
                                    currentPage === n ? "current" : ""
                                  } `}
                                  key={i}
                                  onClick={() => changeCPage(n)}
                                >
                                  {n}
                                </Link>
                              );
                            } else if (i === 1 || i === number.length - 2) {
                              return <span key={i}>...</span>;
                            } else {
                              return null;
                            }
                          } else {
                            return (
                              <Link
                                className={`paginate_button ${
                                  currentPage === n ? "current" : ""
                                } `}
                                key={i}
                                onClick={() => changeCPage(n)}
                              >
                                {n}
                              </Link>
                            );
                          }
                        })}
                      </span>

                      <Link
                        className="paginate_button next"
                        to="#"
                        onClick={nextPage}
                      >
                        <i className="fa-solid fa-angle-right" />
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <LandsaleOffcanvas
        canvasShowAdd={canvasShowAdd}
        seCanvasShowAdd={seCanvasShowAdd}
        Title="Add Land Sale"
        parentCallback={handleCallback}
      /> */}
      <CouponOffcanvas
        canvasShowAdd={canvasShowAdd}
        seCanvasShowAdd={seCanvasShowAdd}
        Title="Add Coupon"
        parentCallback={handleCallback}
      />
      {/* <BulkCouponUpdateOffcanvas
        canvasShowEdit={canvasShowEdit}
        seCanvasShowEdit={seCanvasShowEdit}
        Title={
          selectedCoupon?.length === 1 ? "Edit Coupon" : "Bulk Edit Coupons"
        }
        parentCallback={handleCallback}
        selectedCoupon={selectedCoupon}
      /> */}

      {/* <BulkLandsaleUpdate
        canvasShowEdit={canvasShowEdit}
        seCanvasShowEdit={seCanvasShowEdit}
        Title={
          selectedLandSales?.length === 1
            ? "Edit Land Sale"
            : "Bulk Edit Land Sales"
        }
        parentCallback={handleCallback}
        selectedLandSales={selectedLandSales}
      /> */}

      <Offcanvas
        show={showOffcanvas}
        onHide={setShowOffcanvas}
        className="offcanvas-end customeoff"
        placement="end"
      >
        <div className="offcanvas-header border-bottom">
          <h5 className="modal-title" id="#gridSystemModal">
            Coupon Details{" "}
          </h5>
          <button
            type="button"
            className="btn-close"
            onClick={() => {
              setShowOffcanvas(false);
              clearLandSaleDetails();
            }}
          >
            <i className="fa-solid fa-xmark"></i>
          </button>
        </div>
        {isFormLoading ? (
          <div className="d-flex justify-content-center align-items-center mb-5 mt-5">
            <ClipLoader color="#4474fc" />
          </div>
        ) : (
          <div className="offcanvas-body">
            <div className="container-fluid">
              <div style={{ marginTop: "10px" }}>
                <div className="d-flex flex-wrap align-items-center gap-4 mt-2">
                  <label
                    className="fs-18 mt-3"
                    // style={{ marginTop: "5px", width: "400px" }}
                  >
                    <b>Coupon code:</b>&nbsp;
                    <span>{couponDetails?.title}</span>
                  </label>
                  <label className="fs-18 mt-3">
                    <b>Expiry date:</b>&nbsp;
                    <span>
                      {<DateComponent date={couponDetails?.valid_until} /> ||
                        "NA"}
                    </span>
                  </label>

                  <label className="fs-18 mt-3">
                    <b>Flat discount:</b>&nbsp;
                    <span>${Math.trunc(couponDetails?.value)}</span>
                  </label>
                </div>

                <br />
                <div className="table-responsive active-projects style-1 ItemsCheckboxSec shorting mt-3">
                  <div
                    id="employee-tbl_wrapper"
                    className="dataTables_wrapper no-footer"
                  >
                    <table
                      id="empoloyees-tblwrapper"
                      className="table ItemsCheckboxSec dataTable no-footer product-table-price mb-0"
                    >
                      <thead>
                        <tr style={{ textAlign: "center" }}>
                          <th>
                            <strong>No.</strong>
                          </th>
                          <th>
                            <strong>Name</strong>
                          </th>
                          <th>
                            <strong>Last name</strong>
                          </th>
                          <th>
                            <strong>Company</strong>
                          </th>
                          <th>
                            <strong>Email</strong>
                          </th>
                          <th>
                            <strong>Used at</strong>
                          </th>
                        </tr>
                      </thead>
                      <tbody style={{ textAlign: "center" }}>
                        {couponDetails.users &&
                        Array.isArray(couponDetails.users) &&
                        couponDetails.users.length > 0 ? (
                          couponDetails.users.map((element, index) => (
                            <tr
                              // onClick={() =>
                              //   handlePriceClick(element.id, element.date)
                              // }
                              key={element.id}
                              style={{
                                textAlign: "center",
                                cursor: "pointer",
                              }}
                            >
                              <td>{index + 1}</td>
                              <td>{element?.name ?? ""}</td>
                              <td style={{ textAlign: "center" }}>
                                {element?.last_name ?? ""}
                              </td>
                              <td style={{ textAlign: "center" }}>
                                {element?.company ?? ""}
                              </td>
                              <td style={{ textAlign: "center" }}>
                                {element?.email ?? ""}
                              </td>
                              <td style={{ textAlign: "center" }}>
                                {element?.pivot?.used_at === null ? "Not used" : <DateComponent date={element?.pivot?.used_at} /> ?? ""}
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="3" style={{ textAlign: "center" }}>
                              No data found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
                <br />
              </div>
            </div>
          </div>
        )}
      </Offcanvas>
    </Fragment>
  );
};

export default CouponList;
